import { render, staticRenderFns } from "./OrderData.vue?vue&type=template&id=e8952daa&scoped=true"
import script from "./OrderData.vue?vue&type=script&lang=js"
export * from "./OrderData.vue?vue&type=script&lang=js"
import style0 from "./OrderData.vue?vue&type=style&index=0&id=e8952daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8952daa",
  null
  
)

export default component.exports